module.exports = __webpack_public_path__ + "static/img/u160.35590ee.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/figma/u160.png
// module id = 66lR
// module chunks = 0